import { render, staticRenderFns } from "./TutorsList.vue?vue&type=template&id=56079ad0&scoped=true&"
import script from "./TutorsList.vue?vue&type=script&lang=js&"
export * from "./TutorsList.vue?vue&type=script&lang=js&"
import style0 from "./TutorsList.vue?vue&type=style&index=0&id=56079ad0&lang=scss&scoped=true&"
import style1 from "./TutorsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56079ad0",
  null
  
)

export default component.exports